"use strict";

var image = document.querySelector('.content-img');
var productBox = document.querySelector('.product-info');
var index = 0;
var imgURLs = ["../img/lg-product1.jpeg", "../img/lg-product2.jpg", "../img/lg-product3.jpeg"];
var seconds = 4;

function imageCycle() {
  window.clearTimeout();
  image.style.backgroundImage = "url(".concat(imgURLs[index], ")");
  index++;
  if (index >= imgURLs.length) index = 0;
  setTimeout(function () {
    imageCycle();
    fadeInEffect(productBox);
  }, 7000);
}

function fadeInEffect(fadeTarget) {
  var op = 0.1;
  var timer = setInterval(function () {
    if (op >= 1) {
      clearInterval(timer);
    }

    fadeTarget.style.opacity = op;
    op += 0.1;
  }, 100);
}

imageCycle();